import React from 'react';
import './Logo.css';

const Logo = ({ size = 'medium', dark = false }) => {
  return (
    <div className={`hairkus-logo ${size} ${dark ? 'dark' : ''}`}>
      <div className="logo-icon">
        <img src="/images/logo.png" alt="HAIRKUS Logo" />
      </div>
      <div className="logo-text">
        <span className="logo-hair">HAIR</span>
        <span className="logo-kus">KUS</span>
      </div>
    </div>
  );
};

export default Logo;
